
export const sanitizeAutoComplete = (
    value: string | boolean | undefined
  ): string | undefined => {
    if (typeof value === "boolean") return value ? "on" : "off";
    return value;
  };